/**
 * Important Date Edit Component
 * Form for editing existing important dates
 */

import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  DateInput,
  NumberInput,
  BooleanInput,
  required,
  useRecordContext,
} from 'react-admin';
import { Typography, Box } from '@mui/material';
import { DATE_TYPE_CHOICES } from '../constants';
import { UserSelectInput } from './shared/UserSelectInput';

/**
 * Title for the edit page
 */
function ImportantDateTitle() {
  const record = useRecordContext();
  return <span>Edit Important Date {record ? `"${record.name}"` : ''}</span>;
}

export function ImportantDateEdit() {
  return (
    <Edit title={<ImportantDateTitle />}>
      <SimpleForm>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
          <Typography variant="h6" gutterBottom>Important Date Details</Typography>

          <UserSelectInput
            source="userId"
            label="User"
            disabled
          />

          <TextInput
            source="name"
            label="Name"
            validate={required()}
            fullWidth
          />

          <Box sx={{ display: 'flex', gap: 2 }}>
            <DateInput
              source="date"
              label="Date"
              validate={required()}
            />

            <SelectInput
              source="type"
              label="Type"
              choices={DATE_TYPE_CHOICES}
              validate={required()}
              sx={{ minWidth: 200 }}
            />
          </Box>

          <TextInput
            source="notes"
            label="Notes"
            multiline
            rows={2}
            fullWidth
          />

          <Box sx={{ display: 'flex', gap: 2 }}>
            <NumberInput
              source="reminderOffset"
              label="Reminder Offset (days)"
              helperText="Days before the date to send reminder"
            />

            <NumberInput
              source="partnerReminderOffset"
              label="Partner Reminder Offset (days)"
              helperText="Days before to remind partner"
            />
          </Box>

          <BooleanInput
            source="sharedWithPartner"
            label="Shared with Partner"
          />
        </Box>
      </SimpleForm>
    </Edit>
  );
}
